import { createTranslatedText, dateFormatter, TranslatableText } from '@dreryk/react-common';

import { visitPaths } from '~libs.desktop.shared.paths';

import { useAppointmentsFiltersContext } from '../AppointmentFilter.context';

import { ChipFilter } from './ChipFilter';
import { DateFilter, DateFilterType } from './DateChipFilter.types';

const useDateText = (dateFilter: DateFilter | null): TranslatableText | null => {
   if (!dateFilter) {
      return null;
   }

   if (dateFilter.type === DateFilterType.TODAY) {
      return 'visit:appointments:filters:today';
   }

   if (dateFilter.type === DateFilterType.RANGE) {
      const startDate = dateFilter.range.lowerEndpoint();
      const endDate = dateFilter.range.upperEndpoint();

      return createTranslatedText(`${dateFormatter(startDate)} - ${dateFormatter(endDate)}`);
   }

   return createTranslatedText(dateFormatter(dateFilter.range.lowerEndpoint()));
};

export const DateChipFilter = (): JSX.Element | null => {
   const { getFilter } = useAppointmentsFiltersContext();

   const dateFilter = getFilter('date');
   const dateText = useDateText(dateFilter);

   if (!dateText) {
      return null;
   }

   return (
      <ChipFilter
         label={dateText}
         searchParamKey={visitPaths.APPOINTMENTS_DATE_SEARCH_PARAM}
         testId={'dateChipFilter'}
      />
   );
};
